import React, { Fragment, useEffect, useState } from "react";
import Project from "../../api/project";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import CtaSection from "../../components/CtaSection/CtaSection";
import "./portfolio.css";
import PortfolioCarousel from "./carousel";

const PortfolioSinglePage = (props) => {
  const { slug } = useParams();
  const PortfolioDetails = Project.find((item) => item.slug === slug);
  console.log("🚀 ~ PortfolioSinglePage ~ PortfolioDetails:", PortfolioDetails);

  const [, setMainImage] = useState(PortfolioDetails.pImg);

  // Reset mainImage when slug changes
  useEffect(() => {
    if (PortfolioDetails) {
      setMainImage(PortfolioDetails.pImg);
    }
  }, [slug, PortfolioDetails]);

  const ClickHandler = () => {
    setMainImage(PortfolioDetails.pImg);

    window.scrollTo(10, 0);
  };

  return (
    <Fragment>
      <main className="page_content about-page">
        <PageTitle
          pageTitle={PortfolioDetails.title}
          pageTop={"Portfolio"}
        />
        <section className="portfolio_details_section section_space bg-light">
            <PortfolioCarousel PortfolioDetails={PortfolioDetails} />
          <div className="cont-sec">

            <div class="row">
              <div class="col-lg-12">
                <div class="portfolio-card">
                  <div class="portfolio-header" >
                    <h2  className="txt-clr">{PortfolioDetails.title}</h2>
                  </div>
                  <div class="portfolio-body">
                    <p class="description txt-justify">
                      {PortfolioDetails.description}
                    </p>
                    <p class="support-text txt-justify">
                      Providing comprehensive training and support, we leave no stone unturned in ensuring the success of this project. With our expertise and dedication, we empower our client to embrace the full potential of Mental Health Monitoring, driving innovation.
                    </p>
                    <div class="portfolio-info">
                      <div><strong className="txt-clr">Services:</strong> {PortfolioDetails.services}</div>
                      <div><strong className="txt-clr">Industry:</strong> {PortfolioDetails.Industry}</div>
                      <div><strong className="txt-clr">Location:</strong> {PortfolioDetails.location}</div>
                      <div><strong className="txt-clr">Completed Date:</strong> {PortfolioDetails.completedDate}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12">
                <div class=" portfolio-card">
                  <h3 className="project-requirements  txt-clr">
                    Project Requirement
                  </h3>
                  <p class="description txt-justify">
                    {PortfolioDetails.projectRequirement}
                  </p>
                  <div class="portfolio-info">
                    {PortfolioDetails.features.map((feature, index) => (
                      <div key={index}>
                        <strong>{feature}</strong>
                      </div>
                    ))}
                  </div>
                  <hr />
                  <h3 class="project-requirements txt-clr">Solution & Result</h3>
                  <p class="description txt-justify">
                    {PortfolioDetails.solutionResult}
                  </p>
                  {/* <p class="description">
                    To achieve successful outcomes, our solution includes a
                    comprehensive approach that encompasses meticulous planning,
                    advanced techniques, and thorough testing. We leverage
                    industry-leading tools and expertise.
                  </p> */}
                </div>
              </div>
            </div>

            <h3 className="details_item_info_title pt-5 mb-4 txt-cent">
              Our Similar Projects
            </h3>

            <div className="row">
              {Project.filter(
                (project) => project.id !== PortfolioDetails.id
              ).map((project, prj) => (
                <div className="col-lg-6 col-md-6 col-sm-12" key={prj}>
                  <div
                    className="portfolio_block portfolio_layout_2"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      alignItems: "center",
                      textAlign: "center",
                      marginBottom: "20px",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                      borderRadius: "12px",
                      overflow: "hidden",
                    }}
                  >
                    {/* Image Section */}
                    <div
                      className="portfolio_image"
                      style={{
                        width: "100%",
                        height: "auto",
                        overflow: "hidden",
                      }}
                    >
                      <Link
                        onClick={ClickHandler}
                        className="portfolio_image_wrap bg-light"
                        to={`/portfolio_details/${project.slug}`}
                      >
                        <img
                          src={project.pImg}
                          alt={project.title}
                          loading="lazy"
                          decoding="async"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </Link>
                    </div>

                    {/* Content Section */}
                    <div
                      className="portfolio_content"
                      style={{
                        padding: "20px",
                        width: "100%",
                      }}
                    >
                      <h3
                        className="portfolio_title"
                        style={{
                          fontSize: "1.2rem",
                          fontWeight: "bold",
                          marginBottom: "10px",
                        }}
                      >
                        <Link
                          onClick={ClickHandler}
                          to={`/portfolio_details/${project.slug}`}
                          style={{
                            textDecoration: "none",
                            color: "#333",
                          }}
                        >
                          {project.title}
                        </Link>
                      </h3>
                      <ul
                        className="category_list unordered_list"
                        style={{
                          listStyle: "none",
                          padding: 0,
                          margin: 0,
                          display: "flex",
                          justifyContent: "center",
                          gap: "10px",
                          flexWrap: "wrap",
                        }}
                      >
                        <li>
                          <Link
                            onClick={ClickHandler}
                            to={`/portfolio_details/${project.slug}`}
                            style={{
                              textDecoration: "none",
                              color: "#777",
                              fontSize: "0.9rem",
                            }}
                          >
                            <i className="fa-solid fa-tags"></i>{" "}
                            {project.thumb1}
                          </Link>
                        </li>
                        <li>
                          <Link
                            onClick={ClickHandler}
                            to={`/portfolio_details/${project.slug}`}
                            style={{
                              textDecoration: "none",
                              color: "#777",
                              fontSize: "0.9rem",
                            }}
                          >
                            <i className="fa-solid fa-building"></i>{" "}
                            {project.thumb2}
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
        <CtaSection />
      </main>
      <Scrollbar />
    </Fragment>
  );
};
export default PortfolioSinglePage;
